<mat-card class="cardWithShadow" [attr.dir]="translate.currentLang === 'ar' ? 'rtl' : 'ltr'">
    <mat-card-content>
        <div class="service-info ">
            <div class="row">
                <div class="info-item col-lg-6">
                    <div class="info-label">{{ 'Contact.Info.NameEn' | translate }}:</div>
                    <div class="info-value">{{contactInfoData.nameEn}}</div>
                </div>

                <div class="info-item col-lg-6">
                    <div class="info-label"> {{ 'Contact.Info.NameAr' | translate }}:</div>
                    <div class="info-value">{{ contactInfoData.nameAr }}</div>
                </div>
            </div>
        </div>
    </mat-card-content>
</mat-card>

<app-contact-detail #contactDetailRef (addComplete)="onAddComplete()" [detailsData]="child2Data"
    [contactInfoId]="contactInfoId" [apiName]="apiNameChanged" [hidden]="!amenityHasContactInfo"
    *appHasPermission="[lookupPermissions.Sys_Lookup , lookupPermissions.Contact_Management ,lookupPermissions.Sys_ContactDetailScreen, lookupPermissions.Sys_ContactDetailAdd ,lookupPermissions.Sys_ContactDetailUpdate]"></app-contact-detail>

<app-contact-detail-list #contactDetailListRef (onUpdate)="sendDetailsData($event)" [hidden]="!amenityHasContactInfo"
    *appHasPermission="[lookupPermissions.Sys_Lookup , lookupPermissions.Contact_Management ,lookupPermissions.Sys_ContactDetailScreen, lookupPermissions.Sys_ContactDetailViewList ]"></app-contact-detail-list>